<div
  id="mobile-navigation-drawer"
  class="mobile-nav-drawer"
  [class.mobile-nav-drawer--open]="open()"
  [attr.aria-hidden]="!open()"
  [attr.inert]="open() ? null : ''"
>
  <button
    type="button"
    class="mobile-nav-drawer__backdrop"
    [attr.aria-label]="'navigation.closeMenu' | translate"
    [tabIndex]="open() ? 0 : -1"
    (click)="close()"
  ></button>

  <section
    class="mobile-nav-drawer__panel sb-panel"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'navigation.drawerLabel' | translate"
    [cdkTrapFocus]="open()"
  >
    <header class="mobile-nav-drawer__header">
      <div class="mobile-nav-drawer__brand">
        <span class="mobile-nav-drawer__eyebrow">{{ 'navigation.menu' | translate }}</span>
        <img class="mobile-nav-drawer__brand-logo" [src]="session.currentTheme() === 'dark' ? brand.logoOnDark : brand.logo" [alt]="brand.name" />
      </div>

      <button
        #closeButton
        type="button"
        class="mobile-nav-drawer__close"
        [attr.aria-label]="'navigation.closeMenu' | translate"
        (click)="close()"
      >
        <span class="material-symbols-outlined mobile-nav-drawer__close-icon" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="mobile-nav-drawer__content sb-scrollbar">
      @for (section of navSections; track section.labelKey) {
        <section class="mobile-nav-drawer__section">
          <div class="mobile-nav-drawer__section-heading">{{ section.labelKey | translate }}</div>

          @for (item of section.items; track item.labelKey ?? item.label) {
            <section class="mobile-nav-drawer__group">
              @if (item.children?.length) {
                <div class="mobile-nav-drawer__heading">
                  <span>{{ item.labelKey ? (item.labelKey | translate) : item.label }}</span>
                </div>

                <div class="mobile-nav-drawer__children">
                  @for (child of item.children; track child.labelKey ?? child.label) {
                    @if (child.route) {
                      <a
                        class="mobile-nav-drawer__child"
                        [routerLink]="child.route"
                        routerLinkActive="mobile-nav-drawer__item--active"
                        [routerLinkActiveOptions]="{ exact: child.route === '/' }"
                        ariaCurrentWhenActive="page"
                        (click)="close()"
                      >
                        <span>{{ child.labelKey ? (child.labelKey | translate) : child.label }}</span>
                        <span class="material-symbols-outlined mobile-nav-drawer__item-icon" aria-hidden="true">chevron_right</span>
                      </a>
                    } @else {
                      <button type="button" class="mobile-nav-drawer__child" (click)="close()">
                        <span>{{ child.labelKey ? (child.labelKey | translate) : child.label }}</span>
                        <span class="material-symbols-outlined mobile-nav-drawer__item-icon" aria-hidden="true">chevron_right</span>
                      </button>
                    }
                  }
                </div>
              } @else {
                @if (item.route) {
                  <a
                    class="mobile-nav-drawer__item"
                    [routerLink]="item.route"
                    routerLinkActive="mobile-nav-drawer__item--active"
                    [routerLinkActiveOptions]="{ exact: item.route === '/' }"
                    ariaCurrentWhenActive="page"
                    (click)="close()"
                  >
                    <span>{{ item.labelKey ? (item.labelKey | translate) : item.label }}</span>
                    <span class="material-symbols-outlined mobile-nav-drawer__item-icon" aria-hidden="true">chevron_right</span>
                  </a>
                } @else {
                  <button
                    type="button"
                    class="mobile-nav-drawer__item"
                    [class.mobile-nav-drawer__item--active]="item.active"
                    (click)="close()"
                  >
                    <span>{{ item.labelKey ? (item.labelKey | translate) : item.label }}</span>
                    <span class="material-symbols-outlined mobile-nav-drawer__item-icon" aria-hidden="true">chevron_right</span>
                  </button>
                }
              }
            </section>
          }
        </section>
      }
    </div>

    <footer class="mobile-nav-drawer__footer">
      <section class="mobile-nav-drawer__section mobile-nav-drawer__section--preferences">
        <div class="mobile-nav-drawer__section-heading">{{ 'navigation.sections.preferences' | translate }}</div>
        <div class="mobile-nav-drawer__preference-list">
          <app-theme-switcher></app-theme-switcher>
        </div>
      </section>

      @if (session.currentUser(); as user) {
        <div class="mobile-nav-drawer__balance">
          <span class="mobile-nav-drawer__balance-label">{{ 'header.balance' | translate }}</span>
          <button type="button" class="balance-toggle" (click)="balanceVisibility.toggle()"
                  [title]="(balanceVisibility.hidden() ? 'header.showBalance' : 'header.hideBalance') | translate">
            <strong class="mobile-nav-drawer__balance-value" [class.is-masked]="balanceVisibility.hidden()"
                    [attr.aria-hidden]="balanceVisibility.hidden() ? 'true' : null">
              @if (balanceVisibility.hidden()) {
                <span class="balance-mask-stars">****</span>,<span class="balance-mask-stars">**</span>
              } @else {
                {{ user.Credit | currency:'EUR':'symbol':'1.2-2':session.currentLanguage() }}
              }
            </strong>
            <span class="material-symbols-outlined balance-toggle__icon" aria-hidden="true">{{ balanceVisibility.hidden() ? 'visibility_off' : 'visibility' }}</span>
            <span class="balance-toggle__label">{{ (balanceVisibility.hidden() ? 'header.showBalance' : 'header.hideBalance') | translate }}</span>
          </button>
        </div>
      }
    </footer>
  </section>
</div>
